<script>
import AuthLayout from '@layouts/auth.vue'
import { authMethods } from '@state/helpers'

export default {
  page: {
    title: 'Kvietimas prisijungti',
  },

  components: { AuthLayout },

  data() {
    return {
      password: '',
      password2: '',
      errorMessage: null,
      isLoading: false,
    }
  },

  methods: {
    ...authMethods,

    onSubmitForm() {
      if (!this.password) {
        this.errorMessage = 'Įveskite slaptažodį.'
        return
      }
      if (!this.password2) {
        this.errorMessage = 'Pakartokite įvestą slaptažodį.'
        return
      }
      if (this.password !== this.password2) {
        this.password2 = ''
        this.errorMessage = 'Pakartokite teisingai įvestą slaptažodį.'
        return
      }

      this.isLoading = true
      this.errorMessage = null

      return this.passwordChange({
        email: this.email,
        password: this.password,
        token: this.$route.params.token,
      })
        .then((token) => {
          this.isLoading = false
          this.$router.push({ name: 'login' })
        })
        .catch(() => {
          this.isLoading = false
          this.errorMessage = 'Pakvietimo nuoroda jau nebegalioja.'
        })
    },
  },
}
</script>

<template>
  <AuthLayout>
    <template v-slot:title> Kvietimas prisijungti </template>

    <p v-if="errorMessage" class="text-error mb-4">
      {{ errorMessage }}
    </p>

    <form @submit.prevent="onSubmitForm">
      <div class="mb-4">
        <base-label-input
          v-model="password"
          label="Naujas slaptažodis"
          type="password"
          :error="!!errorMessage"
          autofocus
        />
      </div>

      <div class="mb-4">
        <base-label-input
          v-model="password2"
          label="Pakartokite slaptažodį"
          type="password"
          :error="!!errorMessage"
        />
      </div>

      <div>
        <base-submit :loading="isLoading" class="btn-auth">
          Sukurti paskyrą
        </base-submit>
      </div>
    </form>

    <div class="mt-8 text-center font-medium text-sm">
      <router-link :to="{ name: 'login' }"> Prisijungti </router-link>
    </div>
  </AuthLayout>
</template>
